import { ActionSanitizer } from 'store/devToolsActionSantizer.ts';
import { AnyAction } from 'store/store.ts';
import {
    PortfolioActionType,
    PortfolioSetSelectionAction,
} from 'portfolio/store/actions.ts';

export const portfolioSetSelectionActionSanitizer: ActionSanitizer = <
    A extends AnyAction,
>(
    action: A
) => {
    if (action.type !== PortfolioActionType.PORTFOLIO_SET_SELECTION) {
        return action;
    }

    const portfolioSetSelectionAction =
        action as unknown as PortfolioSetSelectionAction;

    return {
        type: PortfolioActionType.PORTFOLIO_SET_SELECTION + '_SANITIZED',
        payload: {
            symbology: portfolioSetSelectionAction.payload?.symbology,
            overridingActiveInput:
                portfolioSetSelectionAction.payload?.overridingActiveInput,
            first100SelectedSymbols: (
                portfolioSetSelectionAction.payload?.selectedSymbols ?? []
            ).slice(0, 100),
            selectedSymbolsLength:
                portfolioSetSelectionAction.payload?.selectedSymbols.length ??
                0,
            first100AelectedSymbolQuantities: (
                portfolioSetSelectionAction.payload?.selectedSymbolQuantities ??
                []
            ).slice(0, 100),
            selectedSymbolQuantitiesLength:
                portfolioSetSelectionAction.payload?.selectedSymbolQuantities
                    .length ?? 0,
            first100AelectedPositions: (
                portfolioSetSelectionAction.payload?.selectedPositions ?? []
            ).slice(0, 100),
            selectedPositionsLength:
                portfolioSetSelectionAction.payload?.selectedPositions.length ??
                0,
            first100SelectedOrders: (
                portfolioSetSelectionAction.payload?.selectedOrders ?? []
            ).slice(0, 100),
            selectedOrdersLength:
                portfolioSetSelectionAction.payload?.selectedOrders.length ?? 0,
        },
    } as unknown as A;
};
